import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { PosUserSettings } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const usePosUserSettingsPost = () => {
  const { t } = useTranslation();
  const branchId = useBranchId();

  const mutation = useMutation({
    mutationFn: (body: Omit<PosUserSettings, "item_id">) =>
      put2(`internal/secure/pos/v1/user/pos/setting/${branchId}`, body),
    onSuccess: () => {
      toast.success(t("success.update"));
    },
  });
  return mutation;
};

export default usePosUserSettingsPost;
